<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @close="alertContent=''"/>
        <div id="user-degrees">
            <div class="container table-responsive">
                <table class="table table-hover table-borderless">
                    <thead>
                    <tr>
                        <th class="th-first-reduce">ردیف</th>
                        <th>عنوان</th>
                        <th>توضیحات</th>
                        <th>تاریخ آخرین ویرایش</th>
                        <th class="th-last-reduce">عملیلت</th>
                    </tr>
                    </thead>
                    <tbody v-if="documents">
                    <tr class="data-container" v-for="(document, index) in documents" :key="document">
                        <td>
                            <div>{{ index + 1  }}</div>
                        </td>
                        <td>
                            <div v-if="document.type=='resume'">رزومه</div>
                            <div v-else-if="document.type=='passport'">پاسپورت</div>
                            <div v-else-if="document.type=='educationalDegrees'">مدارک تحصیلی</div>
                            <div v-else-if="document.type=='jobCertificate'">گواهی شغل</div>
                            <div v-else-if="document.type=='identityCardTranslation'">ترجمه شناسنامه</div>
                            <div v-else-if="document.type=='otherDocumentsOne'">سایر مدارک</div>
                            <div v-else>سایر مدارک</div>
                        </td>
                        <td>
                            <textarea v-on:keyup="(e)=>updateExplain(e,index)" class="explain-textarea" v-model="document.explain"/>
                        </td>
                        <td>
                            <div>{{document.updated_at}}</div>
                        </td>
                        <td>
                            <div>
                                <a v-on:click="downloadFileRequest(index,document.id)" :class="{active : document.id}" :style="[document.id ? {'color': 'black'} : {'color': 'lightgray'}]">
                                    نمایش
                                </a>
                                |
                                <input v-on:change="e=>uploadFile(e,index)" class="file_input" type="file" name="file" :id="['file_' + index]"/>
                                <label :for="['file_' + index]" class="form_label">بارگذاری</label>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    <PanelLoader v-if="loadingMood"/>

</template>
<script>
    import axios from 'axios'
    import Alert from "../../components/Alert"
    import PanelLoader from "../../components/PanelLoader"
    const FileDownload = require('js-file-download');
    export default {
        name: "UserDocuments",
        data(){
            return {
                alertContent:null,
                loadingMood:false,
                documents:null,
                data: {
                        explain:null,
                        type:null,
                        file:null,
                    }
            }
        },
        components:{
            Alert,
            PanelLoader
        },
        methods:{

            async uploadFile(e,index){
                try {
                    this.loadingMood=true;
                    const formData = new FormData();
                    formData.append('type', this.documents[index].type);
                    formData.append('file', e.target.files[0]);
                    if(this.documents[index].explain!=null){
                        formData.append('explain',this.documents[index].explain);
                    }else{
                        formData.append('explain','');
                    }
                    let response = await axios.post('/api/userDashboard/clientDocumentStore',formData,
                    {
                        headers:
                            {
                            "Authorization": `Bearer ${localStorage.getItem('token')}`,
                            "Content-Type": "multipart/form-data",
                            }
                    });
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'فایل با موفقیت ارسال شد!',
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                    this.documents[index]=response.data.result;
                }
                catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        notice:error.response.data.errors,
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },

            async getData(){
                try {
                    this.loadingMood=true;
                    const response = await axios.get('api/userDashboard/clientDocuments',{headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood=false;
                    const data=response.data.documents;
                    this.documents=data;
                } catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },
            
            async updateExplain(e,index){
                if(e.code == "Enter"){
                    if(this.documents[index].id!=null){
                        try {
                            this.loadingMood=true;
                            await axios.post('/api/userDashboard/clientDocumentExplainEdit',
                                {
                                    data: {explain:this.documents[index].explain,id:this.documents[index].id}
                                },
                                {
                                    headers:
                                        {
                                            "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                        }
                                });
                            this.loadingMood=false;
                        } catch (error) {
                            this.loadingMood=false;
                            this.alertContent={
                                message: 'خطا در انجام عملیات!',
                                notice:error.response.data.errors,
                                imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                                buttonType:'close',//close
                                buttonText:'تایید',
                                buttonLink:'',///personal-info
                                waitingMode:false
                            };
                        }
                    }
                }
            },


            async downloadFileRequest(index,file_id){
                try {
                    this.loadingMood=true;

                    const response = await

                        axios.get(
                        '/api/userDashboard/clientDownloadFileRequest/clientDocument/'+file_id,
                        {
                            headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`},
                            responseType: 'blob'
                        },
                        );


                    FileDownload(response.data,'canada-az-iran.'+this.documents[index].file_type);

                    this.loadingMood=false;
                } catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },
        },
        created(){
        this.getData();
        }
    }
</script>

<style lang="scss" scoped>
    .file_input{
        position: absolute;
        visibility: hidden;
    }
    .form_label{
        cursor: pointer;
    }
    .form_label:hover , .active:hover{
        color: #fe7063;
    }
   .active:hover{
        color: #fe7063!important;
    }
    .explain-textarea{
        width: 220px;
        height: 50px;
        border-radius: 10px;
        border: 1px solid #e3e3e3;
        padding: 5px;

    }
    table{
        margin: auto;
        min-width: max-content!important;
        width: 100%;
    }
    .payment-status-payed{
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4ad41a;
    }
    .payment-event-payed{
        color: #e3e3e3;
    }

    .data-container{
        cursor: pointer;
        border-bottom: 1px solid #e3e3e3!important;
    }
    th , td {
        text-align: center;
    }
    td{
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #162336;
        padding: 8px;
        div{
            height: 100%;
            width: auto;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }

    .th-first-reduce{
        border-top-right-radius:10px;
        border-bottom-right-radius:10px;
    }
    .th-last-reduce{
        border-top-left-radius:10px;
        border-bottom-left-radius:10px;
    }
    table{
    thead{
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
        background-color: rgba(232,232,232,0.5)
    }
    }
    #user-degrees{
        width: 100%;
        height: 100%;
        padding: 30px;
    }

    #user-degrees{
        padding: 20px 30px;
    }
</style>